import React, {Component} from 'react';
import {connect} from 'react-redux';
import Head from '../../../Structure/components/Head/Head';
import Footer from '../../../Structure/components/Footer/Footer';
// import FormAnimalContainer from './FormAnimalContainer';
import FormInsertAnimalContainer from './FormInsertAnimalContainer';
import FormModificarAnimalContainer from './FormModificarAnimalContainer';
import Alert from 'react-s-alert';
import AlertsConteiner from '../../../Shared/components/Alerts/AlertsConteiner';
import WaitBlock from "../../../Shared/components/Alerts/WaitBlock";
import {changeStepWaitBlock, showWaitBlock} from "../../../Structure/actions/actionsStructure";
import {loadInfoAnimalDetail, resetInfoAnimalDetail} from '../../../Animal/actions/actionsAnimal';

import {browserHistory} from "react-router";
import {
    changeAnimalDetail,
    insertAnimalDetail,
    sendImagesAnimal,
    sendMainImageAnimal
} from '../../actions/actionsAnimal';
import {checkIsLogin} from "../../../AdminProtectora/actions/actionsAdmin";
import {PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_NUEVO, PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN} from "../../../../App/RouterAdopta";

const ANIMALS_CONTROL = "animalsProtectora"


class FormAnimalPage extends Component {
    
    constructor(props) {
        
        super(props);
        this.props.checkIsLogin();
        
        if (props.params.id === undefined || props.params.id === "nuevo") {
            this.props.resetInfoAnimalDetail(ANIMALS_CONTROL);
            this.insertMode = true;
            
        } else if (this.isMongoId(props.params.id)) {
            this.props.resetInfoAnimalDetail(ANIMALS_CONTROL);
            this.props.loadInfoAnimalDetail(props.params.id, ANIMALS_CONTROL)
            // this.loadAnimal(props.params.id, ANIMALS_CONTROL);
            this.insertMode = false;
        } else {
            this.props.resetInfoAnimalDetail(ANIMALS_CONTROL);
            this.insertMode = true;
            browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_NUEVO);
        }
        
        this.state = {
            messageLoader: "Guardando datos..."
        }
        
        
        this.EventWaitBlock = this.EventWaitBlock.bind(this);
        this.animalSave = this.animalSave.bind(this);
        this.loadAnimal = this.loadAnimal.bind(this);
        this.animalInsert = this.animalInsert.bind(this);
        this.isMongoId = this.isMongoId.bind(this);
    }
    
    isMongoId(str) {
        return (typeof str === 'string' && /^[0-9A-F]+$/i.test(str) && str.length === 24);
    }
    
    
    animalSave(animal) {
        //console.log("FormAnimalPage::animalSave()")
        animal.insert = false;
        animal._id = this.props.infoAnimalDetail._id;
        // this.setState({animal: {...animal}});
        this.setState({
            ...this.state,
            animal: {...animal}
        });
        this.props.changeStepWaitBlock(0);
        this.props.changeWaitBlock(true);
    }
    
    animalInsert(animal) {
        //console.log("FormAnimalPage::animalInsert()")

        animal.insert = true;
        // this.setState({animal: {...animal}});
        this.setState({
            ...this.state,
            animal: {...animal}
        });
        this.props.changeStepWaitBlock(0);
        this.props.changeWaitBlock(true);
    }
    
    loadAnimal(id) {
        //console.log("FormAnimalPage::loadAnimal()")
        const that = this;
        
        $.ajax({
                //Cambiar a type: POST si necesario
                type: "GET",
                //Datos que se envian
                //data: JSON.stringify(datos),
                data: {
                    tipo: "completa"
                },
                // Formato de datos que se espera en la respuesta
                dataType: "json",
                // URL a la que se enviará la solicitud Ajax
                url: "/api/animal/" + id,
            })
            .done(function (response, textStatus, jqXHR) {
                // console.log(response);
                that.setState({...response})
                // that.setState({
                //     name: data.nombre,
                //     //nif: data.NIF,
                //     email: data.email,
                //     direccion: data.direccion.calle,
                //     numDir: data.direccion.numero,
                //     facebook: data.facebook.nick,
                //     instagram: data.instagram.nick,
                //     twitter: data.twitter.nick,
                //     URL: data.url,
                //     telefonos: data.telefonos,
                //     descripcion: data.descripcion,
                //     loaded: true,
                //     imageData: data.img_principal,
                //     galeria_imagenes_protectora: data.galeria_imagenes
                // });
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }
                
                if (console && console.log) {
                    //console.log("La solicitud a fallado: " + errorStr);
                }
            });
        
    }
    
    EventWaitBlock(event) {
        if (event === "go") {
            this.setState({
                messageLoader: "Guardando datos..."
            })
            if (this.insertMode && !this.props.infoAnimalDetail._id) {
                this.props.insertAnimalDetail(this.state.animal, this.props.access);
            } else if (this.insertMode && this.props.infoAnimalDetail._id) {
                this.props.changeAnimalDetail({
                    ...this.state.animal,
                    _id: this.props.infoAnimalDetail._id
                }, this.props.access);
            } else {
                this.props.changeAnimalDetail(this.state.animal, this.props.access);
            }
        } else if (event === 2) {
            this.setState({
                messageLoader: "Guardando imagen principal..."
            })
            this.props.sendMainImageAnimal({
                ...this.state.animal,
                _id: this.props.infoAnimalDetail._id ? this.props.infoAnimalDetail._id : this.state.animal._id
            }, this.props.access);
            
        } else if (event === 3) {
            this.setState({
                messageLoader: "Guardando galería de fotos..."
            })
            this.props.sendImagesAnimal({
                ...this.state.animal,
                _id: this.props.infoAnimalDetail._id ? this.props.infoAnimalDetail._id : this.state.animal._id
            }, this.props.access);
        } else {
            if (this.props.stepWaitBlock === 200 || this.props.stepWaitBlock === 201) {
                
                Alert.success('Guardado correctamente', {
                    position: 'top-right',
                    effect: 'slide',
                    timeout: 6000,
                    customFields: {
                        messageItem: 2,
                        showIconClosed: true,
                        icon: "las la-2x la-info-circle"
                    }
                });
            } else {
                let timeout
                if (this.props.stepWaitBlock === 401) {
                    if (!this.props.access.isLogin) {
                        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN);
                        timeout = 1000
                    }
                }
                setTimeout(()=>{Alert.error('Error: ' + this.props.errorWaitBlock, {
                    position: 'top-right',
                    effect: 'slide',
                    timeout: 6000,
                    customFields: {
                        messageItem: 2,
                        showIconClosed: true,
                        icon: "las la-2x la-exclamation-triangle"
                    }
                });},timeout || 0)
                
            }
            
            // const animalId = this.props.infoAnimalDetail._id ? this.props.infoAnimalDetail._id : this.state.animal._id || this.props.stepWaitBlock
            const animalId = this.props.infoAnimalDetail._id ? this.props.infoAnimalDetail._id : this.state.animal._id;
            if (animalId) {
                this.props.loadInfoAnimalDetail(animalId, "animalsProtectora");
            }
            this.props.changeStepWaitBlock(0);
            this.props.changeWaitBlock(false);
            // console.log("yendo a /admin");
            // browserHistory.push('/admin');
            
        }
    }
    
    render() {
        //console.log("FormAnimalPage::render()")
        const id = (this.props.params && this.props.params.id) ? this.props.params.id : undefined;
        console.log("FormAnimalPage::render() -> this.insertMode = " +this.insertMode)
        return (
            <div>
                <Head
                    previousPath={"animalDetail"}
                />
                {this.props.showWaitBlock &&
                    <WaitBlock
                        message={this.state.messageLoader}
                        methodChange={this.EventWaitBlock}
                    />
                }
                <div id="animals-list" className="container main-content">
                    <div className="page-login__wrap">
                        <h2 className="page-login__heading">{(this.insertMode) ? "Añadir nuevo animal" : "Modificar animal"}</h2>
                    </div>
                    
                    <div>
                        {/*<FormAnimalContainer*/}
                        {/*    animalsControl={"animalsProtectora"}*/}
                        {/*    animalsControlDetail={"animalDetailProtectora"}*/}
                        {/*    handleChange={this.animalSave}*/}
                        {/*    handleInsert={this.animalInsert}*/}
                        {/*    params={{id: id}}*/}
                        {/*    insertMode={this.insertMode}*/}
                        {/*/>*/}
                        {(this.insertMode)?
                            <FormInsertAnimalContainer
                                animalsControl={"animalsProtectora"}
                                animalsControlDetail={"animalDetailProtectora"}
                                // handleChange={this.animalSave}
                                handleInsert={this.animalInsert}
                                // params={{id: id}}
                                // insertMode={this.insertMode}
                            />
                            :
                            <FormModificarAnimalContainer
                                animalsControl={"animalsProtectora"}
                                animalsControlDetail={"animalDetailProtectora"}
                                handleChange={this.animalSave}
                                // handleInsert={this.animalInsert}
                                params={{id: id}}
                                // insertMode={this.insertMode}
                            />


                        }

                    </div>
                    <Alert stack={true} html={true} contentTemplate={AlertsConteiner}/>
                </div>
                <Footer
                    percent={100}
                    configFooter={{"moreInfo": false}}
                />
            </div>
        );
    }
    
    componentWillMount() {
        //console.log("FormAnimalPage::componentWillMount()")
        if (!this.props.access.isLogin) {
            browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN);
            setTimeout(()=>{Alert.error('Error: ' + "Debe iniciar sesión antes", {
                position: 'top-right',
                effect: 'slide',
                timeout: 6000,
                customFields: {
                    messageItem: 2,
                    showIconClosed: true,
                    icon: "las la-2x la-exclamation-triangle"
                }
            });},1000)
        }
        
        
        //Initial scroll
        let element = $("body");
        if (element.length !== 0) {
            //console.log("Haciendo scrollTop");
            $('body,html').stop(true, true).animate({scrollTop: 0}, 0);
        }
        
        this.props.changeStepWaitBlock(0);
        this.props.changeWaitBlock(false);
    }
    
    componentDidMount() {
        //console.log("FormAnimalPage::componentDidMount()")
        // $('#animals-filter').addClass('animated-0s fadeIn');
        
        // let animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        
        if (!this.props.showHead) {
            // $('.header-topbar').addClass('animated-400ms fadeInDown').one(animationEnd, () => {
            //     $('.header-topbar').removeClass('animated-400ms fadeInDown');
            // });
            //$('.header-topbar').css("visibility", "visible");
        } else {
            // $('.header-topbar').removeClass('animated-400ms fadeInDown');
            //$('.header-topbar').css("visibility", "visible");
        }
        
        if (!this.props.showFooter) {
            // $('.footer-default').addClass('animated-400ms fadeIn');
            $('.footer-default').show();
        } else {
            // $('.footer-default').removeClass('animated-400ms fadeIn');
            $('.footer-default').show();
        }
    }
    
    componentDidUpdate() {
        //console.log("FormAnimalPage::componentDidUpdate()")
        
        if (this.props.showWaitBlock) {
            $('#modal-container').removeClass('out').addClass("one");
            $('body').addClass('modal-active');
        } else {
            $('#modal-container').removeClass('one').addClass('out');
            $('body').removeClass('modal-active');
        }
    }
    
    componentWillUpdate(nextProps, nextState, nextContext) {
    }
    
    componentWillReceiveProps(nextProps, nextContext) {
    }
    
}

function mapStateToProps(state) {
    return {
        infoAnimalDetail: state["animalDetailProtectora"].infoAnimalDetail,
        showHead: state.structureControl.showHead,
        showFooter: state.structureControl.showFooter,
        showWaitBlock: state.structureControl.showWaitBlock,
        stepWaitBlock: state.structureControl.stepWaitBlock,
        errorWaitBlock: state.structureControl.errorWaitBlock,
        access: state.access
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {
    changeWaitBlock: showWaitBlock,
    changeStepWaitBlock,
    changeAnimalDetail,
    loadInfoAnimalDetail,
    insertAnimalDetail,
    sendMainImageAnimal,
    sendImagesAnimal,
    checkIsLogin,
    resetInfoAnimalDetail
})(FormAnimalPage)
